import { render, staticRenderFns } from "./down.vue?vue&type=template&id=556d6836&scoped=true&"
import script from "./down.vue?vue&type=script&lang=js&"
export * from "./down.vue?vue&type=script&lang=js&"
import style0 from "./down.vue?vue&type=style&index=0&id=556d6836&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d6836",
  null
  
)

export default component.exports